export type QueryParams = Record<string, string | string[] | boolean | undefined>;

// took this list from SearchPage.tsx, seems like they want this list to live in the search package
// so we can import that when that happens
export const SEARCH_PAGE_QUERY_PARAM_KEYS = [
	'product',
	'type',
	'lastModified',
	'titleMatch',
	'createdBy',
	'contributors',
	'owners',
	'spaces',
	'pageStatus',
	'verified',
	'ancestor',
	'labels',
	'archived',
	'jAssignee',
	'jProject',
	'jReporter',
	'jWatchedByMe',
	'jCommentedByMe',
	'referrer',
	'focusAreaTypes',
	'focusAreaUnder',
	'leftExperiments',
	'rightExperiments',
	'from',
	'to',
	'lastUpdatedBy',
	'status',
	'compassArchived',
	'assetsSchema',
	'assetsType',
] as const;
export interface IframeSearchPageProps {
	queryParams: QueryParams;
	queryString: string;
	searchSessionId: string;
	testId?: string;
}
